const fontFamily = ['"Nunito"', 'sans-serif'].join(',');

const typography = { fontFamily };

export default typography;
